import { PeriodUserSettingObj } from "@va/core-library/period-filter";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import {
  IndustryUserTabSettings,
  IndustryUserIndustrySettings,
} from "src/app/store/models/industry-page.model";

@Injectable({
  providedIn: "root",
})
export class SectorsAndIndustriesPageDataService {
  apiEP: string = window.apiUrl;

  constructor(private http: HttpClient) {}

  getSectorMeta(): Observable<any> {
    return this.http.get(`${this.apiEP}/api/sector_meta/`);
  }

  getIndustryDetailsBySector(sectorId: number): Observable<any> {
    return this.http.get(
      `${this.apiEP}/api/get_industry_details_by_sector/?sector_id=${sectorId}`,
    );
  }

  getCompGroupsAndCompaniesCoveredCount(): Observable<any> {
    return this.http.get(`${this.apiEP}/api/get_va_companies_covered_count/`);
  }

  getIndustryMeta(
    industryId: number,
    tabName: string,
    subIndustryId = -1,
    regionIds = [-1],
    marketCapIds = [-1],
    countryIds = [],
  ): Observable<any> {
    const subIndustry = `&subindustry_id=${subIndustryId || -1}`;
    let region = "";
    if (regionIds && regionIds.length) {
      region = `&region_id=${regionIds.join("&region_id=")}`;
    }
    let country = "";
    if (countryIds && countryIds.length) {
      country = `&country_id=${countryIds.join("&country_id=")}`;
    }
    let marketCap = "";
    if (marketCapIds && marketCapIds.length) {
      marketCap = `&market_cap=${marketCapIds.join("&market_cap=")}`;
    }

    return this.http.get(
      `${this.apiEP}/industry_page/get_industry_meta?industry_id=${industryId}&tab=${tabName}${subIndustry}${region}${marketCap}${country}`,
    );
  }

  downloadIndustryExport(
    params: string,
    subIndustryId = -1,
    regionIds = [-1],
    marketCapIds = [-1],
    countryIds = [],
  ): Observable<any> {
    const subIndustry = `&subindustry_id=${subIndustryId || -1}`;
    let region = "";
    if (regionIds && regionIds.length) {
      region = `&region_id=${regionIds.join("&region_id=")}`;
    }
    let country = "";
    if (countryIds && countryIds.length) {
      country = `&country_id=${countryIds.join("&country_id=")}`;
    }
    let marketCap = "";
    if (marketCapIds && marketCapIds.length) {
      marketCap = `&market_cap=${marketCapIds.join("&market_cap=")}`;
    }
    return this.http.get(
      `${this.apiEP}/addin/export?${params}${subIndustry}${region}${marketCap}${country}`,
    );
  }

  getStdLineItems(
    tickers: Array<string>,
    showSuggestedLineItems = false,
    currency = "USD",
  ): Observable<any> {
    const reqObj: {
      tickers: Array<string>;
      show_suggested_lines: boolean;
      currency?: string;
    } = { tickers, show_suggested_lines: showSuggestedLineItems };

    if (currency) {
      reqObj.currency = currency;
    }
    return this.http.post(`${this.apiEP}/comps/get_std_line_items`, reqObj);
  }

  saveUserSettings(
    regions: Array<string>,
    marketCap: Array<string>,
    currency: string,
    period: PeriodUserSettingObj,
    industryId: number,
    removeBlankRows: boolean,
  ): Observable<any> {
    const reqObj = {
      jsondata: {
        market_cap: marketCap,
        region: regions,
        currency: currency,
        remove_blanks: removeBlankRows,
      },
      userindustrydata: {
        period,
      },
      industryid: industryId,
    };
    return this.http.post(
      `${this.apiEP}/industry_page/save_user_settings`,
      reqObj,
    );
  }

  /**
   * It makes post call to save user's tab settings
   * @param {string} tabId - tab id
   * @param {IndustryUserTabSettings} data - selected info of filters
   */
  saveUserIndustryTabSettings(
    tabId,
    data: IndustryUserTabSettings,
  ): Observable<any> {
    const reqObj = {
      [tabId]: data,
    };
    return this.http.post(
      `${this.apiEP}/industry_page/save_user_industry_tab_settings`,
      reqObj,
    );
  }

  /**
   * It makes post call to save user's industry settings
   * @param {IndustryUserIndustrySettings} data - selected info of market cap, region
   */
  saveUserIndustrySettings(
    data: IndustryUserIndustrySettings,
  ): Observable<any> {
    return this.http.post(
      `${this.apiEP}/industry_page/save_user_industry_settings`,
      data,
    );
  }

  getTotalLogic(lineId: number) {
    return this.http.get(
      `${this.apiEP}/industry_page/total_logic_check?line_id=${lineId}`,
    );
  }

  getIndustryTabData(params): Observable<any> {
    return this.http.get(
      `${this.apiEP}/industry_page/get_industry_data?${params}`,
    );
  }

  getCompaniesFilter(data): Observable<any> {
    return this.http.post(
      `${this.apiEP}/industry_page/get_industry_cluster_data`,
      data,
    );
  }

  saveFilterData(data): Observable<any> {
    return this.http.post(
      `$(this.apiEP)/industry_page/set_industry_cluster_data`,
      data,
    );
  }

  getFormattedLineName(
    uniquesliId,
    industryId,
    currency,
    ticker,
  ): Observable<any> {
    return this.http.get(
      `${this.apiEP}/industry_page/get_formatted_line_name?ticker=${ticker}&uniquesliid=${uniquesliId}&industry_id=${industryId}&currency=${currency}`,
    );
  }
}
